import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { JSONMap as t } from "../../core/jsonMap.js";
import { JSONSupport as s } from "../../core/JSONSupport.js";
import { clone as i } from "../../core/lang.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import { Integer as a } from "../../core/accessorSupport/ensureType.js";
import { reader as l } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import n from "./AuthoringInfoFieldInfo.js";
import u from "./AuthoringInfoVisualVariable.js";
import { types as p, fromJSON as c } from "../../rest/support/colorRamps.js";

var _d;

var h = new t({
  esriClassifyDefinedInterval: "defined-interval",
  esriClassifyEqualInterval: "equal-interval",
  esriClassifyManual: "manual",
  esriClassifyNaturalBreaks: "natural-breaks",
  esriClassifyQuantile: "quantile",
  esriClassifyStandardDeviation: "standard-deviation"
}),
    y = new t({
  classedSize: "class-breaks-size",
  classedColor: "class-breaks-color",
  univariateColorSize: "univariate-color-size",
  relationship: "relationship",
  predominance: "predominance",
  dotDensity: "dot-density"
}),
    m = ["inches", "feet", "yards", "miles", "nautical-miles", "millimeters", "centimeters", "decimeters", "meters", "kilometers", "decimal-degrees"],
    v = ["high-to-low", "above-and-below", "above", "below", "90-10"],
    f = ["caret", "circle-caret", "arrow", "circle-arrow", "plus-minus", "circle-plus-minus", "square", "circle", "triangle", "happy-sad", "thumb", "custom"];

var b = _d = /*#__PURE__*/function (_s) {
  _inherits(d, _s);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this.colorRamp = null, _this.lengthUnit = null, _this.maxSliderValue = null, _this.minSliderValue = null, _this.visualVariables = null;
    return _this;
  }

  _createClass(d, [{
    key: "classificationMethod",
    get: function get() {
      var e = this._get("classificationMethod"),
          t = this.type;

      return t && "relationship" !== t ? "class-breaks-size" === t || "class-breaks-color" === t ? e || "manual" : null : e;
    },
    set: function set(e) {
      this._set("classificationMethod", e);
    }
  }, {
    key: "readColorRamp",
    value: function readColorRamp(e) {
      if (e) return c(e);
    }
  }, {
    key: "fields",
    get: function get() {
      return this.type && "predominance" !== this.type ? null : this._get("fields");
    },
    set: function set(e) {
      this._set("fields", e);
    }
  }, {
    key: "field1",
    get: function get() {
      return this.type && "relationship" !== this.type ? null : this._get("field1");
    },
    set: function set(e) {
      this._set("field1", e);
    }
  }, {
    key: "field2",
    get: function get() {
      return this.type && "relationship" !== this.type ? null : this._get("field2");
    },
    set: function set(e) {
      this._set("field2", e);
    }
  }, {
    key: "focus",
    get: function get() {
      return this.type && "relationship" !== this.type ? null : this._get("focus");
    },
    set: function set(e) {
      this._set("focus", e);
    }
  }, {
    key: "numClasses",
    get: function get() {
      return this.type && "relationship" !== this.type ? null : this._get("numClasses");
    },
    set: function set(e) {
      this._set("numClasses", e);
    }
  }, {
    key: "statistics",
    get: function get() {
      return "univariate-color-size" === this.type && "above-and-below" === this.univariateTheme ? this._get("statistics") : null;
    },
    set: function set(e) {
      this._set("statistics", e);
    }
  }, {
    key: "standardDeviationInterval",
    get: function get() {
      var e = this.type;
      return e && "relationship" !== e && "class-breaks-size" !== e && "class-breaks-color" !== e || this.classificationMethod && "standard-deviation" !== this.classificationMethod ? null : this._get("standardDeviationInterval");
    },
    set: function set(e) {
      this._set("standardDeviationInterval", e);
    }
  }, {
    key: "type",
    get: function get() {
      return this._get("type");
    },
    set: function set(e) {
      var t = e;
      "classed-size" === e ? t = "class-breaks-size" : "classed-color" === e && (t = "class-breaks-color"), this._set("type", t);
    }
  }, {
    key: "univariateSymbolStyle",
    get: function get() {
      return "univariate-color-size" === this.type && "above-and-below" === this.univariateTheme ? this._get("univariateSymbolStyle") : null;
    },
    set: function set(e) {
      this._set("univariateSymbolStyle", e);
    }
  }, {
    key: "univariateTheme",
    get: function get() {
      return "univariate-color-size" === this.type ? this._get("univariateTheme") : null;
    },
    set: function set(e) {
      this._set("univariateTheme", e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _d({
        classificationMethod: this.classificationMethod,
        colorRamp: i(this.colorRamp),
        fields: this.fields && this.fields.slice(0),
        field1: i(this.field1),
        field2: i(this.field2),
        focus: this.focus,
        numClasses: this.numClasses,
        maxSliderValue: this.maxSliderValue,
        minSliderValue: this.minSliderValue,
        lengthUnit: this.lengthUnit,
        statistics: this.statistics,
        standardDeviationInterval: this.standardDeviationInterval,
        type: this.type,
        visualVariables: this.visualVariables && this.visualVariables.map(function (e) {
          return e.clone();
        }),
        univariateSymbolStyle: this.univariateSymbolStyle,
        univariateTheme: this.univariateTheme
      });
    }
  }]);

  return d;
}(s);

e([r({
  type: h.apiValues,
  value: null,
  json: {
    type: h.jsonValues,
    read: h.read,
    write: h.write,
    origins: {
      "web-document": {
        default: "manual",
        type: h.jsonValues,
        read: h.read,
        write: h.write
      }
    }
  }
})], b.prototype, "classificationMethod", null), e([r({
  types: p,
  json: {
    write: !0
  }
})], b.prototype, "colorRamp", void 0), e([l("colorRamp")], b.prototype, "readColorRamp", null), e([r({
  type: [String],
  value: null,
  json: {
    write: !0
  }
})], b.prototype, "fields", null), e([r({
  type: n,
  value: null,
  json: {
    write: !0
  }
})], b.prototype, "field1", null), e([r({
  type: n,
  value: null,
  json: {
    write: !0
  }
})], b.prototype, "field2", null), e([r({
  type: ["HH", "HL", "LH", "LL"],
  value: null,
  json: {
    write: !0
  }
})], b.prototype, "focus", null), e([r({
  type: Number,
  value: null,
  json: {
    type: a,
    write: !0
  }
})], b.prototype, "numClasses", null), e([r({
  type: m,
  json: {
    type: m,
    read: !1,
    write: !1,
    origins: {
      "web-scene": {
        read: !0,
        write: !0
      }
    }
  }
})], b.prototype, "lengthUnit", void 0), e([r({
  type: Number,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1,
        read: !1
      }
    }
  }
})], b.prototype, "maxSliderValue", void 0), e([r({
  type: Number,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1,
        read: !1
      }
    }
  }
})], b.prototype, "minSliderValue", void 0), e([r({
  type: Object,
  value: null,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1,
        read: !1
      }
    }
  }
})], b.prototype, "statistics", null), e([r({
  type: [.25, .33, .5, 1],
  value: null,
  json: {
    type: [.25, .33, .5, 1],
    write: !0
  }
})], b.prototype, "standardDeviationInterval", null), e([r({
  type: y.apiValues,
  value: null,
  json: {
    type: y.jsonValues,
    read: y.read,
    write: y.write
  }
})], b.prototype, "type", null), e([r({
  type: [u],
  json: {
    write: !0
  }
})], b.prototype, "visualVariables", void 0), e([r({
  type: f,
  value: null,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1
      }
    }
  }
})], b.prototype, "univariateSymbolStyle", null), e([r({
  type: v,
  value: null,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1
      }
    }
  }
})], b.prototype, "univariateTheme", null), b = _d = e([o("esri.renderers.support.AuthoringInfo")], b);
var w = b;
export { w as default };